import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {WarningModalContentComponent} from './warning-modal.component';
import {WarningModalService} from "../../services/warning-modal/warning-modal.service";
import { BannerModule, ButtonModule } from '@xref/xref-lib';

@NgModule({
    imports: [
        CommonModule,
      BannerModule,
      ButtonModule
    ],
    exports: [],
    declarations: [
        WarningModalContentComponent
    ],
    providers: [
        WarningModalService
    ]
})
export class WarningModalModule {
}
